<template>
	<!-- 侧边栏的每一个小项目 -->
  <div v-if="!item.hidden" class="menu-wrapper">
	<!-- item只有一个 children  -->
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
		<!-- 代连接的Item -->
	  <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
		<el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>
	
	<!-- 具有子菜单的  -->
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>

	  <!-- Item （icon，title） -->
	  <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
	  <!-- 是嵌套循环？ -->
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
//  Path使用说明
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item' // Item 名称和svg 组件
import AppLink from './Link' // 连接组件
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  // 组件参数，通过使用此组件的组件传递参数
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
	// 参数 
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  methods: {
	  /**
	   * 仅有一个子模块
	   */
    hasOneShowingChild(children = [], parent) {
		//过滤 children 数组
      const showingChildren = children.filter(item => {
        // 
		if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    /**
	 * 分解转换路径
	* @param {Object} routePath
	*/
	resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
